import { lendingApiFetchJson } from 'lendingApi/lendingApi';
import { DuplicateEmailError, mintCognitoUserForSignup } from 'utils/authApi';
import { URLS } from 'utils/tests/urls.config';
import { TDeserialisedIntroducerFormData } from '../registration.types';

type TSubmitReferralForm = {
  values: TDeserialisedIntroducerFormData;
  onSuccess: () => void | Promise<void>;
  onError: () => void;
  onDuplicateEmail: () => void;
};

export const submitReferralRegistrationForm = async ({
  values,
  onSuccess,
  onError,
  onDuplicateEmail,
}: TSubmitReferralForm) => {
  const introducerValues = {
    title: values.title,
    first_name: values.firstName,
    last_name: values.lastName,
    email: values.email,
    phone_number: values.phoneNumber,
  };

  try {
    const signedUpWithCognito = await mintCognitoUserForSignup(values.email);
    const url = signedUpWithCognito
      ? URLS.signupIntroducer()
      : URLS.postIntroducer();
    // Using lendingApiFetchJson as we need to send the FE tokens due to the user not being logged in
    await lendingApiFetchJson(url, {
      method: 'post',
      body: JSON.stringify({
        data: { ...introducerValues, introducer_company_id: values.uuid },
      }),
    });
    await onSuccess();
    return;
  } catch (error) {
    if (error instanceof DuplicateEmailError) {
      onDuplicateEmail();
      return;
    }
    onError();
  }
};
